import AuthService from '@/services/AuthService';

export const exam = {
  namespaced: true,
  state: {
    incomplete_completion: null,
    incomplete_completion_online: null,
    home_work: null,
    old_home_work: null
  },
  actions: {
    incompleteCompletion({ commit }, student_id) {
      return AuthService.incomplete_completion(student_id).then(
        incomplete_completion => {
          commit('incompleteCompletionSuccess', incomplete_completion);
          return Promise.resolve(incomplete_completion);
        },
        error => {
          commit('incompleteCompletionFailure', error);
          return Promise.reject(error);
        },
      );
    },
    incompleteCompletionOnline({ commit }, student_id) {
      return AuthService.incomplete_completion_online(student_id).then(
        incomplete_completion_online => {
          commit('incompleteCompletionOnlineSuccess', incomplete_completion_online);
          return Promise.resolve(incomplete_completion_online);
        },
        error => {
          commit('incompleteCompletionOnlineFailure', error);
          return Promise.reject(error);
        },
      );
    },
    homeWork({ commit }, student_id) {
      return AuthService.home_work(student_id).then(
        home_work => {
          commit('homeWorkSuccess', home_work);
          return Promise.resolve(home_work);
        },
        error => {
          commit('homeWorkFailure', error);
          return Promise.reject(error);
        },
      );
    },
    oldHomeWork({ commit }, student_id) {
      return AuthService.old_home_work(student_id).then(
        home_work => {
          commit('oldHomeWorkSuccess', home_work);
          return Promise.resolve(home_work);
        },
        error => {
          commit('oldHomeWorkFailure', error);
          return Promise.reject(error);
        },
      );
    },
    logout({ commit }) {
      commit('logoutSuccess');
    }
  },
  mutations: {
    incompleteCompletionSuccess(state, incomplete_completion) {
      state.incomplete_completion = incomplete_completion;
    },
    incompleteCompletionFailure(state) {
      state.incomplete_completion = {};
    },
    incompleteCompletionOnlineSuccess(state, incomplete_completion_online) {
      state.incomplete_completion_online = incomplete_completion_online;
    },
    incompleteCompletionOnlineFailure(state) {
      state.incomplete_completion_online = {};
    },
    homeWorkSuccess(state, home_work) {
      state.home_work = home_work;
    },
    oldHomeWorkSuccess(state, home_work) {
      state.old_home_work = home_work;
    },
    homeWorkFailure(state) {
      state.home_work = {};
    },
    oldHomeWorkFailure(state) {
      state.old_home_work = {};
    },
    logoutSuccess(state) {
      state.incomplete_completion = null;
      state.home_work = null;
      state.old_home_work = null
    }
  }
};